/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 7r312uiqyadpVPdnRoAggk
// Component: fKBGdItR62E2

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import ProfileActions from "../../ProfileActions"; // plasmic-import: VtINgkEb27Pn/component
import More from "../../More"; // plasmic-import: _AH4Ju8JTju3/component
import ProfileInfo from "../../ProfileInfo"; // plasmic-import: rFaRrp2J8jq8/component
import Button from "../../Button"; // plasmic-import: oVzoHzMf1TLl/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 7r312uiqyadpVPdnRoAggk/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 7r312uiqyadpVPdnRoAggk/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: 7r312uiqyadpVPdnRoAggk/projectcss
import sty from "./PlasmicProfileHead.module.css"; // plasmic-import: fKBGdItR62E2/css

import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: YUYx96s4ZKDV/icon
import ChevronRightIcon from "../fragment_icons/icons/PlasmicIcon__ChevronRight"; // plasmic-import: GHdF3hS-oP_3/icon
import ChevronLeftIcon from "../fragment_icons/icons/PlasmicIcon__ChevronLeft"; // plasmic-import: r9Upp9NbiZkf/icon

createPlasmicElementProxy;

export type PlasmicProfileHead__VariantMembers = {};
export type PlasmicProfileHead__VariantsArgs = {};
type VariantPropType = keyof PlasmicProfileHead__VariantsArgs;
export const PlasmicProfileHead__VariantProps = new Array<VariantPropType>();

export type PlasmicProfileHead__ArgsType = {
  children?: React.ReactNode;
  pageViewCount?: string;
  pageViewPending?: boolean;
  serviceList?: any;
  displayName?: string;
  title?: string;
  subTitle?: string;
  imageUrl?: string;
  slug?: string;
};
type ArgPropType = keyof PlasmicProfileHead__ArgsType;
export const PlasmicProfileHead__ArgProps = new Array<ArgPropType>(
  "children",
  "pageViewCount",
  "pageViewPending",
  "serviceList",
  "displayName",
  "title",
  "subTitle",
  "imageUrl",
  "slug"
);

export type PlasmicProfileHead__OverridesType = {
  root?: Flex__<"div">;
  viewCount?: Flex__<"div">;
  span?: Flex__<"span">;
  svg?: Flex__<"svg">;
  profileActions?: Flex__<typeof ProfileActions>;
  more?: Flex__<typeof More>;
  profileInfo?: Flex__<typeof ProfileInfo>;
};

export interface DefaultProfileHeadProps {
  children?: React.ReactNode;
  pageViewCount?: string;
  pageViewPending?: boolean;
  serviceList?: any;
  displayName?: string;
  title?: string;
  subTitle?: string;
  imageUrl?: string;
  slug?: string;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicProfileHead__RenderFunc(props: {
  variants: PlasmicProfileHead__VariantsArgs;
  args: PlasmicProfileHead__ArgsType;
  overrides: PlasmicProfileHead__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__zmn0Z)}>
        <div className={classNames(projectcss.all, sty.freeBox__exjNw)}>
          <div className={classNames(projectcss.all, sty.freeBox__tuVqM)}>
            <div
              data-plasmic-name={"viewCount"}
              data-plasmic-override={overrides.viewCount}
              className={classNames(projectcss.all, sty.viewCount)}
            >
              <span
                data-plasmic-name={"span"}
                data-plasmic-override={overrides.span}
                className={classNames(
                  projectcss.all,
                  projectcss.span,
                  projectcss.__wab_text,
                  sty.span
                )}
              >
                <React.Fragment>
                  {(() => {
                    try {
                      // Progressive profile: the count is still loading → placeholder, not "NaN".
                      if ($props.pageViewPending) {
                        return (
                          <span
                            aria-hidden="true"
                            className="inline-block align-middle w-[27px] h-[18px] rounded-md bg-slate-200 skeleton-shimmer"
                          />
                        );
                      }
                      const count = Number($props.pageViewCount);
                      if ($props.pageViewCount == null || $props.pageViewCount === "" || !Number.isFinite(count)) {
                        return "";
                      }
                      return Intl.NumberFormat("en", {
                        notation: "compact"
                      }).format($props.pageViewCount);
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "301K";
                      }
                      throw e;
                    }
                  })()}
                </React.Fragment>
              </span>
              <Icon4Icon
                data-plasmic-name={"svg"}
                data-plasmic-override={overrides.svg}
                className={classNames(projectcss.all, sty.svg)}
                role={"img"}
              />
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__m1Kw)}>
              <ProfileActions
                data-plasmic-name={"profileActions"}
                data-plasmic-override={overrides.profileActions}
                className={classNames("__wab_instance", sty.profileActions)}
                slug={(() => {
                  try {
                    return $props.slug;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              />

              <More
                data-plasmic-name={"more"}
                data-plasmic-override={overrides.more}
                className={classNames("__wab_instance", sty.more)}
                slug={(() => {
                  try {
                    return $props.slug;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              />
            </div>
          </div>
        </div>
        <ProfileInfo
          data-plasmic-name={"profileInfo"}
          data-plasmic-override={overrides.profileInfo}
          className={classNames("__wab_instance", sty.profileInfo)}
          displayName={(() => {
            try {
              return $props.displayName;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
          imageUrl={(() => {
            try {
              return $props.imageUrl;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
          serviceList={(() => {
            try {
              return $props.serviceList;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
          subTitle={(() => {
            try {
              return $props.subTitle;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
          title={(() => {
            try {
              return $props.title;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        />

        <div
          className={classNames(
            projectcss.all,
            sty.freeBox__ekp4F,
            "no-scroll"
          )}
        >
          {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
            (() => {
              try {
                return $props.serviceList;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()
          ).map((__plasmic_item_0, __plasmic_idx_0) => {
            const currentItem = __plasmic_item_0;
            const currentIndex = __plasmic_idx_0;
            return (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__yflB8
                )}
                key={currentIndex}
                style={{ width: "max-content", minWidth: "fit-content" }}
              >
                <React.Fragment>
                  {(() => {
                    try {
                      return currentItem;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "\u06a9\u0645\u0631\u062f\u0631\u062f";
                      }
                      throw e;
                    }
                  })()}
                </React.Fragment>
              </div>
            );
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__k5Fnv)}>
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.children
          })}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__dtZp8)}>
        <Button
          children2={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__zfeLn
              )}
            >
              {"\u0646\u0638\u0631\u0627\u062a"}
            </div>
          }
          className={classNames("__wab_instance", sty.button__dq1R5)}
          color={"clear"}
          onClick={async event => {
            const $steps = {};

            $steps["goToReviews"] = true
              ? (() => {
                  const actionArgs = { destination: "#reviews" };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      __nextRouter?.push(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToReviews"] != null &&
              typeof $steps["goToReviews"] === "object" &&
              typeof $steps["goToReviews"].then === "function"
            ) {
              $steps["goToReviews"] = await $steps["goToReviews"];
            }
          }}
        />

        <Button
          children2={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__xcsi
              )}
            >
              {"\u0622\u062f\u0631\u0633 \u0648 \u062a\u0644\u0641\u0646"}
            </div>
          }
          className={classNames("__wab_instance", sty.button__rgvju)}
          color={"clear"}
          onClick={async event => {
            const $steps = {};

            $steps["goToPhoneAndAddress"] = true
              ? (() => {
                  const actionArgs = { destination: "#phone-and-address" };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      __nextRouter?.push(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToPhoneAndAddress"] != null &&
              typeof $steps["goToPhoneAndAddress"] === "object" &&
              typeof $steps["goToPhoneAndAddress"].then === "function"
            ) {
              $steps["goToPhoneAndAddress"] = await $steps[
                "goToPhoneAndAddress"
              ];
            }
          }}
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "viewCount",
    "span",
    "svg",
    "profileActions",
    "more",
    "profileInfo"
  ],
  viewCount: ["viewCount", "span", "svg"],
  span: ["span"],
  svg: ["svg"],
  profileActions: ["profileActions"],
  more: ["more"],
  profileInfo: ["profileInfo"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  viewCount: "div";
  span: "span";
  svg: "svg";
  profileActions: typeof ProfileActions;
  more: typeof More;
  profileInfo: typeof ProfileInfo;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicProfileHead__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicProfileHead__VariantsArgs;
    args?: PlasmicProfileHead__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicProfileHead__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicProfileHead__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicProfileHead__ArgProps,
          internalVariantPropNames: PlasmicProfileHead__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicProfileHead__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProfileHead";
  } else {
    func.displayName = `PlasmicProfileHead.${nodeName}`;
  }
  return func;
}

export const PlasmicProfileHead = Object.assign(
  // Top-level PlasmicProfileHead renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    viewCount: makeNodeComponent("viewCount"),
    span: makeNodeComponent("span"),
    svg: makeNodeComponent("svg"),
    profileActions: makeNodeComponent("profileActions"),
    more: makeNodeComponent("more"),
    profileInfo: makeNodeComponent("profileInfo"),

    // Metadata about props expected for PlasmicProfileHead
    internalVariantProps: PlasmicProfileHead__VariantProps,
    internalArgProps: PlasmicProfileHead__ArgProps
  }
);

export default PlasmicProfileHead;
/* prettier-ignore-end */
